import { render, staticRenderFns } from "./RevokeUser.vue?vue&type=template&id=0ef315d5&"
import script from "./RevokeUser.vue?vue&type=script&lang=js&"
export * from "./RevokeUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports